import React, { useEffect } from "react";
import LifeAtADImg from '../Images/LifeAtAD.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function LifeAtAD() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={LifeAtADImg} alt="Life at Architetive Designs" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Life At Architetive Designs</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Architetive Designs' ambition is to be the world's leading architectural and design practice, investing in people, innovation, and research with sustainability at its core. These principles underpin everything that we do, including the way we live and work on campus.
                    </p>

                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Located next to Battersea Park, our headquarters in London includes a library with over 50,000 publications, an archive, materials research centre, world-class model shops, photography studios, a reprographics centre, and on-site cafés. The cafés serve breakfast, lunch, and dinner, alongside all-day drinks and snacks, with special afternoon treats that are baked on-site every day.
                    </p>

                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Our summer and winter parties are an integral part of our annual social calendar, alongside our annual Graduate Show, which provides recent graduates at Architetive Designs the opportunity to showcase their projects to Architetive Designs and other senior colleagues. We also host our annual Partners’ Gathering, Riverside Festival as part of Open House, offering the public unique insights into the practice's work. There is a regular series of lectures and talks by a range of different speakers as well as social events for all.
                    </p>
                </div>
                <h1 className="text-xl mb-4 text-gray-500">Explore</h1>
                <div className="flex-col space-y-4 mb-8">
                    <div className="space-x-3">
                        <Link to='/careers/vacancies'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                        </Link>
                        <Link to='/careers/early-careers'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Early Careers</button>
                        </Link>
                        <Link to='/careers/benefits'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Benefits</button>
                        </Link>
                    </div>
                    <div>
                        <Link to='/people/equity-diversity-and-inclusion'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Equity, Diversity and Inclusion</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LifeAtAD;